import { type RefObject, useEffect, useRef } from "react";
import { useStore } from "../store";

export const useScrollToWhen = (state: boolean): RefObject<HTMLDivElement> => {
  const store = useStore();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (state) {
      ref.current?.scrollIntoView();
      store.resetScrollTo();
    }
  }, [state]);

  return ref;
};
